import { useLang } from '@/i18n';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';

const E: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const boxRef = useRef<HTMLDivElement>(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneE = AniContainer.create({
                triggerElement: '.stream-ultra-x-C',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            if (!boxRef.current) return () => sceneE.destroy();
            const playingVideo = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const video: HTMLVideoElement | null = document.querySelector('#stream-ultra-x-E video');
                        if (video && entry.isIntersecting) {
                            video.currentTime = 0;
                            video.play();
                        }
                    });
                },
                {
                    threshold: 0.5,
                },
            );
            playingVideo.observe(boxRef.current);
            return () => {
                sceneE.destroy();
                playingVideo.disconnect();
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-E GtmModuleData-section`}
            id="stream-ultra-x-E"
            ref={boxRef}
            data-section-id={'stream-ultra-x-E'}
            data-section-title={t('E_title')}
        >
            <p className="title">{t('E_title')}</p>
            <div className="img">
                {load && (
                    <video
                        src="https://websiteoss.ecoflow.com/upload/video/1755163727999/5.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1754397732932/5-pc.jpg"
                        loop
                        // autoPlay
                        muted
                        playsInline
                        preload="metadata"
                        width="100%"
                        height="100%"
                        aria-label={t('E_title')}
                    />
                )}
            </div>
            <ul className="items">
                {[1, 2, 3]?.map((i: number) => (
                    <li className={`item item-${i}`} key={i}>
                        <p className="item-title">{t(`E_item${i}_title`)}</p>
                        <p className="item-desc">{t(`E_item${i}_desc`)}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default E;
